import axios from 'axios';
import { appOperations } from '../../../../App/store';
import { createObjectCopy } from '../../../../utilities/objectUtilities';
import { trackEvent, AnalyticsConstants } from '../../../../utilities/analyticsUtilities';
import { logout } from '../../../../utilities/authUtilities';

const setReceiveNotificationEmails = (receive, accountDetails) => {
    return dispatch => {
        const detailsCopy = createObjectCopy(accountDetails);
        detailsCopy.receiveVideoNotificationEmails = receive;

        dispatch(appOperations.setAccountDetails(detailsCopy));

        axios.post('/api/account/UpdateReceiveVideoNotificationEmails/' + receive).then(response => {
            if (receive)
                trackEvent('Enabled Export Complete Emails', {
                    category: AnalyticsConstants.ACCOUNT_CATEGORY,
                });
            else
                trackEvent('Disabled Export Complete Emails', {
                    category: AnalyticsConstants.ACCOUNT_CATEGORY,
                });
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => setReceiveNotificationEmails(receive, accountDetails), 'Failed to update preference.'));
            dispatch(appOperations.setAccountDetails(accountDetails));
        });
    }
}

const setReceiveUpdatesOffersEmails = (receive, accountDetails) => {
    return dispatch => {
        const detailsCopy = createObjectCopy(accountDetails);
        detailsCopy.receiveUpdatesAndOffersEmails = receive;

        dispatch(appOperations.setAccountDetails(detailsCopy));

        axios.post('/api/account/UpdateReceiveUpdatesOffersEmails/' + receive).then(response => {
            if (receive)
                trackEvent('Enabled Updates & Offers Emails', {
                    category: AnalyticsConstants.ACCOUNT_CATEGORY,
                });
            else
                trackEvent('Disabled Updates & Offers Emails', {
                    category: AnalyticsConstants.ACCOUNT_CATEGORY,
                });
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => setReceiveUpdatesOffersEmails(receive, accountDetails), 'Failed to update preference.'));
            dispatch(appOperations.setAccountDetails(accountDetails));
        });
    }
}

const setReceivePaymentReceiptsEmails = (receive, accountDetails) => {
    return dispatch => {
        const detailsCopy = createObjectCopy(accountDetails);
        detailsCopy.receivePaymentReceiptsEmails = receive;

        dispatch(appOperations.setAccountDetails(detailsCopy));

        axios.post('/api/account/UpdateReceivePaymentReceiptsEmails/' + receive).then(() => {
            if (receive)
                trackEvent('Enabled Receive receipts emails', {
                    category: AnalyticsConstants.ACCOUNT_CATEGORY,
                });
            else
                trackEvent('Disabled Receive receipts emails', {
                    category: AnalyticsConstants.ACCOUNT_CATEGORY,
                });
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => setReceivePaymentReceiptsEmails(receive, accountDetails), 'Failed to update preference.'));
            dispatch(appOperations.setAccountDetails(accountDetails));
        });
    }
}

const setVideoEncodingCrf = (crf, accountDetails) => {
    return dispatch => {
        const detailsCopy = createObjectCopy(accountDetails);
        detailsCopy.videoEncodingCrf = crf;

        dispatch(appOperations.setAccountDetails(detailsCopy));

        axios.post('/api/account/UpdateVideoEncodingCrf/' + crf).then(() => {
            trackEvent('Updated video encoding CRF', {
                category: AnalyticsConstants.ACCOUNT_CATEGORY,
                crf: crf
            });
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => setVideoEncodingCrf(crf, accountDetails), 'Failed to update preference.'));
            dispatch(appOperations.setAccountDetails(accountDetails));
        });
    }
}

const deleteAccount = () => {
    return dispatch => {
        axios.post('/api/account/DeleteUser').then(response => {
            logout();
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => deleteAccount(), 'Failed to delete account. Contact us at help@specterr.com'));
        });
    }
}

const navigateToStripeCustomerPortal = () => {
    return dispatch => {
        trackEvent('Managed Billing', {
            category: AnalyticsConstants.ACCOUNT_CATEGORY,
        });

        axios.get('/api/plan/GetStripeCustomerPortal').then(response => {
            const customerPortalUrl = response.data;
            window.location = customerPortalUrl;
        }).catch(error => {
            dispatch(appOperations.failRequest(
                error, 
                () => navigateToStripeCustomerPortal(), 
                'Failed to navigate to the customer portal.'
            ));
        });
    }
}

export default {
    setReceiveNotificationEmails,
    setReceiveUpdatesOffersEmails,
    setReceivePaymentReceiptsEmails,
    setVideoEncodingCrf,
    deleteAccount,
    navigateToStripeCustomerPortal
}